module.exports = __webpack_public_path__ + "img/Happy_1.3ef300ba.png";